/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ average: NonNullable<unknown> }} Practice_Trend_FirstInputs */



/**
* | output |
* | --- |
* | "Average {average} — first attempt" |
*
* @param {Practice_Trend_FirstInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_trend_first = /** @type {((inputs: Practice_Trend_FirstInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Trend_FirstInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Gemiddelde ${i?.average} — eerste poging`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Moyenne ${i?.average} — première tentative`)
	return /** @type {LocalizedString} */ (`Average ${i?.average} — first attempt`)
});